import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);
const conf = {
  locale: 'currentLang',
  fallbackLocale: 'currentLang',
  messages: {currentLang: LPT.config.translationMap},
  missing: (locale, key, vm, values) => {
    if (key.includes('.') && !/\s/.test(key)) {
      const newKey = /(.*)\.[^.]+$/.exec(key)[1]
      if (sharedI18n.t(newKey) !== newKey) {
        console.debug("fallback key", newKey)
        return sharedI18n.t(newKey, values ? values[0] : null);
      }
    }
    return key
  },
};
export default conf;
export const sharedI18n = new VueI18n(conf);



// WEBPACK FOOTER //
// ./src/global/i18n/index.js